import { api } from '@jurnee/common/src/browser/Api';
import { PartnerUserJSON, PartnerUserUpdate } from '@jurnee/common/src/entities/PartnerUser';

export async function getUser(id: PartnerUserJSON['id']): Promise<PartnerUserJSON> {
  return api.get(`/partners-users/${id}`);
}

export async function updateUser(id: PartnerUserJSON['id'], data: PartnerUserUpdate): Promise<PartnerUserJSON> {
  return api.put(`/partners-users/${id}`, data);
}